

export const sora = {
    tabs: { textToVideo: '文字轉影片', imageToVideo: '圖片轉影片' },
    upload: { uploadImage: '上傳圖片', formats: 'JPG、PNG、WebP • 最大 10MB' },
    prompt: { label: '提示詞', placeholder: '描述你要生成的影片…', sub: '描述期望的運動與內容', count: '{count} / 5000' },
    model: { title: '模型版本', sora2: 'Sora 2', sora2pro: 'Sora 2 Pro' },
    groups: { aspect: '畫面比例', duration: '時長' },
    options: { landscape: '橫版', portrait: '直版', s10: '10秒', s15: '15秒' },
    toggle: { removeWatermark: '移除浮水印' },
    credits: { bar: '積分消耗', value: '{value} 積分' },
    actions: { generate: '生成影片（{value} 積分）' },
    preview: { title: '準備生成', desc: '輸入提示並點擊生成，用 Sora 2 創作精彩影片' }
  };
